<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      msg: "",
    };
  },
  components: {},
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      console.log(sessionStorage.getItem("store"))
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {},
  methods: {},
};
</script>

<style>
html,
body,
#app {
  width: 100%;
  height: 100%;
  font-weight: 400;
  background: #fff;
}
input {
  border: 0;
}

.el-tabs--border-card {
  box-shadow: none;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #fff;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: #787878;
  font-size: 16px;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #4ec4c7;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #4ec4c7 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue